// Copyright (c) 2021 WiseTime. All rights reserved.

import React from "react"

type Props = {
  name: string,
  className?: string,
  onClick?: () => void,
}

const SvgIcon = ({
  name,
  className = undefined,
  onClick,
}: Props): React.ReactElement<Props> => {
  return (
    <svg
      className={`icon-svg icon-${name}${className ? ` ${className}` : ""}`}
      onClick={onClick}
    >
      <use xlinkHref={`#${name}`} />
    </svg>
  )
}

export default SvgIcon
